export default "__VITE_ASSET__CSYr$IpE__"